import{StaticMultiTagPicker as o}from"./MultiTagPicker.js";import{extendToSingleTagPicker as r}from"./extendToSingleTagPicker.js";const e=r(o);export{e as StaticPicker};
//# sourceMappingURL=StaticPicker.js.map
